// extracted by mini-css-extract-plugin
export var backdropBlur = "_jm-0";
export var contentCard = "_jm-5";
export var frame = "_jm-2";
export var image = "_jm-4";
export var imagePane = "_jm-3";
export var modal = "_jm-1";